import { useJsApiLoader } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getGoogleApiKey } from '../../../utils/helpers/common';
import { getLangDefinition } from '../../../utils/helpers';
import { setError } from '../../../actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

const MapLoaderComponent: React.FC<{
  setErrorUI: (errorState: boolean) => void;
}> = ({ children, setErrorUI }) => {
  const { i18n } = useTranslation();

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: getGoogleApiKey(),
    language: getLangDefinition(i18n.language),
    region: 'AZ'
  });

  useEffect(() => {
    if (loadError) setErrorUI(true);
  }, [loadError]);

  if (!isLoaded) return null;

  return <>{children}</>;
};

export const MapLoader = connect(null, mapDispatchToProps)(MapLoaderComponent);
